import { render } from "./TicketInfoComponent.vue?vue&type=template&id=5b799748&ts=true"
import script from "./TicketInfoComponent.vue?vue&type=script&lang=ts"
export * from "./TicketInfoComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/TCD-GIFTSHOP-CHANNELING-FRONT/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__